import React, { useCallback, useEffect, useState } from 'react'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import { io } from 'socket.io-client'
import { useParams } from 'react-router-dom'

const BACKEND_URL = "https://rayy-docs.herokuapp.com" // http://localhost:3001 || https://rayy-docs.herokuapp.com
const SAVE_TIME_INTERVAL = 2000

// Toolbar Options :
const TOOLBAR_OPTIONS = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ align: [] }],
    ["image", "blockquote", "code-block"],
    ["clean"],
  ]

// TextEditor Functional Component :
function TextEditor() {

    const {id: documentId} = useParams()

    // Defining the Socket State :
    const [ socket, setSocket ] = useState()
    // Defining the Quill State :
    const [ quill, setQuill ] = useState()

    // useEffect for the Socket Connection :
    useEffect(() => {
        const s =io(BACKEND_URL)                             // Defining the Server host 
        setSocket(s)                                        // setting the value of socket

        return() => {
            s.disconnect()                                  // disconnecting the Server connection 
        }
    }, [])

    useEffect(() => {
        if(socket == null || quill == null) return          // Checking the Connection is created or not 

        // Load Document Event :
        socket.once("load-document", document => {
            quill.setContents(document)
            quill.enable()
        })

        socket.emit('get-document', documentId)
    }, [socket, quill, documentId])

    useEffect(() => {
        if(socket == null || quill == null) return          // Checking the Connection is created or not 

        // For Saving The Document :
        const interval = setInterval(()=>{
            socket.emit('save-document', quill.getContents())
        }, SAVE_TIME_INTERVAL)

        return () => {
            clearInterval(interval)
        }
    }, [socket, quill])


    // useEffect that Handles the received changes :
    useEffect(() => {
        if(socket == null || quill == null) return          // Checking the Connection is created or not 

        // change Handler :
        const handler = (delta) => {
            quill.updateContents(delta)
        }
        socket.on('receive-changes', handler)

        return () => {
            socket.off('receive-changes', handler)
        }
    }, [socket, quill])

    // useEffect that Handles the sending the changes :
    useEffect(() => {
        if(socket == null || quill == null) return          // Checking the Connection is created or not 

        // change Handler :
        const handler = (delta, oldDelta, source) => {
            if(source !== 'user') return
            socket.emit("send-changes", delta)
        }
        quill.on('text-change', handler)

        return () => {
            quill.off('text-change', handler)
        }
    }, [socket, quill])

    // Call Back Hook that create an instance of Quill :
    const wrapperRef = useCallback((wrapper) => {
        if ( wrapper == null ) return 

        wrapper.innerHTML = ''
        const editor = document.createElement("div")
        wrapper.append(editor)
         const q = new Quill(editor, { theme: "snow", modules: { toolbar: TOOLBAR_OPTIONS} })
        q.disable()
        q.setText('Loading... ')
         setQuill(q)
    }, []) 

    return (
        <div className='container' ref={wrapperRef}>
            Text Editor
        </div>
    )
}

export default TextEditor
